export default "__VITE_ASSET__DYG8h2IC__"